import { render } from "./SwdPagination.vue?vue&type=template&id=12283045"
import script from "./SwdPagination.vue?vue&type=script&lang=js"
export * from "./SwdPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__